import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Login from "./app/features/login/pages/LoginPage";
import Logger from "./app/utils/Logger";
import { ApiProvider } from "./app/service/ApiContext";
import { AlertProvider } from "./app/components/AlertContextComponent";
import PageViewTracker from "./app/analytics/analytics_pagetracker";
import Dashboard from "./app/features/sideBar/components/DashboardComponent";
import ZoomImageOverlay from "./app/features/assessment/components/ZoomImageOverlayComponent";
import {
  PreventPrtScrKey,
  PreventScreenshotAndPrint,
} from "./app/components/PreventScreenshotAndPrint";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { ReCaptchaService } from "./app/service/ReCaptchaService";
import useNetworkStatus from "./app/hook/useNetworkStatus";
import { HelmetProvider, Helmet } from "react-helmet-async";
import SpeedTestComponent from "./app/components/InternetSpeedTest";

import ChatBotIcon from "./app/features/chatbot/pages/ChatBotIcon";
import CopyPasteProvider from "./app/service/CopyPasteProvider";
import RouteValidator from "./app/service/ApiRoutes";
import ActiveLiveSessionLogo from "./app/features/sideBar/components/ActiveLiveSessionLogo";
import DashboardVersionTwo from "./app/features2/sidebar/components/DashboardComponent";
import CheckCertificates from "./app/features/certficates/pages/CheckCertificationPage";
import LoginVersionTwo from "./app/features2/login/pages/LoginPage";
import ResetPassword from "./app/features2/forgotPassword/components/ResetPasswordPage";
const siteKey = "6Lfbpc8qAAAAAAUADnr8i7yCdk8fjqalPZrNBSOu"; // Replace with your actual site key

declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      execute: (
        siteKey: string,
        options: { action: string },
      ) => Promise<string>;
    };
  }
}

const AppRoutes: React.FC = () => {
  useNetworkStatus();
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
  const location = useLocation();

  // useEffect(() => {
  //   const loadRecaptcha = () => {
  //     if (window.grecaptcha) {
  //       window.grecaptcha.ready(() => {
  //         window.grecaptcha
  //           .execute(siteKey, { action: "homepage" })
  //           .then((token: string) => {
  //             setRecaptchaToken(token);
  //             Logger.info("reCAPTCHA Token:", token);
  //           })
  //           .catch((error) => {
  //           });
  //       });
  //     } else {
  //     }
  //   };

  //   if (
  //     !document.querySelector(
  //       `script[src="https://www.google.com/recaptcha/api.js?render=${siteKey}"]`
  //     )
  //   ) {
  //     const script = document.createElement("script");
  //     script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
  //     script.async = true;
  //     script.onload = loadRecaptcha;
  //     document.body.appendChild(script);

  //     return () => {
  //       document.body.removeChild(script);
  //     };
  //   } else {
  //     loadRecaptcha();
  //   }
  // }, []);

  // return <div>reCAPTCHA Loaded: {recaptchaToken ? "✅" : "⏳"}</div>;
  useEffect(() => {
    const loadReCaptcha = async () => {
      await ReCaptchaService.initiate();
      const token = await ReCaptchaService.getToken("submit");
      Logger.info("Recaptcha Token", token);

      setRecaptchaToken(token);
    };
    Logger.info("ENV:", process.env.REACT_APP_ENVIORNMENT);
    if (process.env.REACT_APP_ENVIORNMENT) {
      Logger.info("recaptchaaa %%%%%%%%%%%%%%%%%%%%5");
      loadReCaptcha();
    }
  }, []);

  Logger.info("Fetching data for ExampleComponent");

  useEffect(() => {
    // Prevent right-click context menu
    const disableRightClick = (e: MouseEvent) => {
      e.preventDefault();
      // alert("Right-click is disabled for security reasons.");
      // showAlert({
      //   show: true,
      //   title: "Error",
      //   message: "Right-click is disabled for security reasons.",
      //   button1Text: "OK",
      //   alertType: "error",
      //   onlyNeedOneButton: true,
      // });
    };

    // // Prevent cut, copy, and paste actions
    // const disableCopyCutPaste = (e: ClipboardEvent) => {
    //   e.preventDefault();
    // };

    // // Add event listeners for context menu and clipboard events
    // document.addEventListener("contextmenu", disableRightClick);
    // document.addEventListener("cut", disableCopyCutPaste);
    // document.addEventListener("copy", disableCopyCutPaste);
    // document.addEventListener("paste", disableCopyCutPaste);

    // // Cleanup event listeners on component unmount
    return () => {
      // document.removeEventListener("contextmenu", disableRightClick);
      //   document.removeEventListener("cut", disableCopyCutPaste);
      //   document.removeEventListener("copy", disableCopyCutPaste);
      //   document.removeEventListener("paste", disableCopyCutPaste);
    };
  }, []);

  return (
    // <GoogleReCaptchaProvider reCaptchaKey="6Lfbpc8qAAAAAAUADnr8i7yCdk8fjqalPZrNBSOu">
    <HelmetProvider>
      <AlertProvider>
        <ApiProvider>
          {process.env.REACT_APP_ENVIORNMENT !== "DEVELOPMENT" && (
            <>
              {" "}
              <PreventScreenshotAndPrint />
            </>
          )}
          <Helmet>
            {/* Default SEO metadata */}
            <title>Jozuna</title>

            <meta
              name="description"
              content="Jozuna platform for managing, learning, and growing seamlessly."
            />
            {/* <meta name="google-site-verification" content="haU-oWMZRqZSXhBMAlVEqVPwy4tef45ZqNlhgOQt8r4" /> */}

            <link rel="canonical" href="https://user.jozuna.com/" />
            <meta
              name="robots"
              content={
                process.env.REACT_APP_ENVIORNMENT === "PRODUCTION"
                  ? "index, follow"
                  : "noindex, nofollow"
              }
            />
          </Helmet>
          <CopyPasteProvider enableCopyPasteIn=".ChatBotModalOverlay, .interview-hub-container, .interview-hub-session-container, .interview-hub-feedback-container">
            <RouteValidator />
            <PageViewTracker /> {/* For Analytics Page Tracking*/}
            <Routes>
              <Route path="/*" element={<LoginVersionTwo />} />
              <Route
                path="/reset_password/user/:token"
                element={<ResetPassword />}
              />
              <Route path="speedtest" element={<SpeedTestComponent />} />

              {/* <Route path="/dashboard/*" element={<Dashboard />} /> */}
              <Route path="/dashboard/*" element={<DashboardVersionTwo />} />

              <Route path="/image" element={<ZoomImageOverlay />} />
              {/* <Route path="/assessment-page" element={<AssessmentBubbleSelector />} /> */}

              {/* <Route path="/dashboard/recommendation" element={<VideoLandingPage />} /> */}

              {/* <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/reset-password" element={<ResetPassword />} /> /reset_password/corporate/:token*/}
            </Routes>
            {location.pathname.startsWith("/dashboard") &&
              !location.pathname.startsWith("/dashboard/assessment") &&
              !location.pathname.startsWith("/dashboard/livesession") && (
                <ActiveLiveSessionLogo />
              )}
            {location.pathname.startsWith("/dashboard") &&
              location.pathname.startsWith("/dashboard/programhub") && (
                <CheckCertificates />
              )}
          </CopyPasteProvider>
        </ApiProvider>
      </AlertProvider>
    </HelmetProvider>
    // </GoogleReCaptchaProvider>
  );
};

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
